import { useAuth0 } from '@auth0/auth0-react';
import { gql } from '@apollo/client/core/index.js';
import { useQuery } from '@apollo/client/react/index.js';

import type {
  SelfQuery,
  SelfQueryVariables,
} from '#src/types/generated/graphql.ts';

const SELF = gql`
  query Self {
    self {
      partner {
        credentialSelfServiceApprovedIndicator
        name
      }
    }
  }
`;

export const useSelf = () => {
  const { isAuthenticated } = useAuth0();
  const { data, loading } = useQuery<SelfQuery, SelfQueryVariables>(SELF, {
    skip: !isAuthenticated,
  });

  return {
    self: data?.self,
    loading,
  };
};
